import { withTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import i18n from '../../../utils/i18n';
import Navigation from '../../regFlow/components/navigation/navigation';
import RadioInput from '../../regFlow/components/searchInputs/radioInput';
import {
  taxFormInput
} from '../data/kftRgFlowText';
import '../kftRegFlow.scss';


const FormOfTaxation = ({ ...props }) => {
  const companyStore = useSelector((state) => state.company_store);

  return (
    <div className='stepContainer'>
      <div className='SFInput'>
        <p className='SFSubTitle'>
          <span className='SFSubTitle'>{i18n.t('kftregflow.formOfTaxationText')}</span>{' '}
        </p>
        <RadioInput
          storeID="taxform"
          dataText={taxFormInput()}
          stateObject="company_store"
        />
      </div>
      <Navigation
        step={0}
        handleNext={() => props.handleNext(1)}
        disabledProp={companyStore.taxform === '' ? true : false}
      />
    </div>
  );
};

export default withTranslation()(FormOfTaxation);
